<div class="mx-3">
  <div class="flex items-center gap-4 cursor-pointer px-3 py-2 rounded-md user-label" [matMenuTriggerFor]="menu" *ngIf="user$ | async as user">
    <div class="relative">
      <div [matTooltip]="user.displayName"
        class="flex items-center justify-center w-9 h-9 min-w-9 rounded-full overflow-hidden">
        <img [src]="user.picture" class="w-full h-full object-contain">
      </div>
      <div class="absolute top-0 -right-1 h-3 w-3 rounded-full bg-gray-300"
        [ngClass]="{'bg-green-400': isConnectedSignalR$ | async}"
        [matTooltip]="(isConnectedSignalR$ | async) ? 'Online' : 'Offline'"></div>
    </div>
    <div class="flex flex-col text-slate-200 user-label-text w-full min-w-15">
      <div class="truncate">{{user.name}}</div>
      <div class="text-sm text-secondary truncate">{{user.email}}</div>
    </div>
    <mat-menu [xPosition]="'before'" #menu="matMenu">
      <div class="px-6 py-2">
        <div class="flex flex-col leading-none">
          <span>Signed in as</span>
          <span class="mt-1.5 text-md font-semibold text-secondary truncate">{{user?.email}}</span>
        </div>
        <span class="underline text-md cursor-pointer" (click)="changePassword(user.email)">Change Password</span>
      </div>
      <mat-divider></mat-divider>
      <button mat-menu-item [matMenuTriggerFor]="settingsMenu">
        <mat-icon [svgIcon]="'mat_outline:settings'"></mat-icon>
        <span>Settings</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()">
        <mat-icon [svgIcon]="'logout'"></mat-icon>
        <span>Sign Out</span>
      </button>
    </mat-menu>
  </div>
</div>

<mat-menu #settingsMenu="matMenu">
  <button mat-menu-item routerLink="{{'/settings/organization/general'}}">
    <mat-icon svgIcon="settings_applications"></mat-icon>
    <span>General</span>
  </button>
  <button mat-menu-item [routerLink]="(isOwner$ | async) ? '/settings/organization/privacy-and-security' : '/settings/member/privacy-and-security'">
    <mat-icon svgIcon="mat_outline:privacy_tip"></mat-icon>
    <span>Privacy and Security</span>
  </button>
  <button *ngIf="isOwner$ | async" mat-menu-item routerLink="{{'/settings/organization/subsciptions-and-billing'}}">
    <mat-icon svgIcon="payments"></mat-icon>
    <span>Subsciptions and billing</span>
  </button>
  <button mat-menu-item [routerLink]="(isOwner$ | async) ? '/settings/organization/apps' : '/settings/member/apps'">
    <mat-icon svgIcon="apps"></mat-icon>
    <span>Apps</span>
  </button>
  <button mat-menu-item [routerLink]="(isOwner$ | async) ? '/settings/organization/about' : '/settings/member/about'">
    <mat-icon svgIcon="mat_outline:info"></mat-icon>
    <span>About</span>
  </button>
</mat-menu>